import React from 'react';
import { FaUsers, FaClock, FaCheckCircle, FaTimesCircle, FaCalendarCheck, FaVideo } from 'react-icons/fa';

const ApplicationStatsCards = ({ dataLength, dashboardStats }) => {
    const kpiItems = [
        {
            title: "Total Auditions",
            value: dataLength,
            icon: <FaUsers />,
            trend: "Applications"
        },
        {
            title: "Total Pending",
            value: dashboardStats.totalPending,
            icon: <FaClock />,
            trend: "Waiting"
        },
        {
            title: "Total Selected",
            value: dashboardStats.totalSelected,
            icon: <FaCheckCircle />,
            trend: "Selected"
        },
        {
            title: "Total Rejected",
            value: dashboardStats.totalRejected,
            icon: <FaTimesCircle />,
            trend: "Rejected"
        },
        {
            title: "Slot Booking",
            value: dashboardStats.totalSlotBooking,
            icon: <FaCalendarCheck />,
            trend: "Walk-In"
        },
        {
            title: "Web Upload",
            value: dashboardStats.totalWebUpload,
            icon: <FaVideo />,
            trend: "Online"
        }
    ];

    return (
        <div className="roles-kpi-grid">
            {kpiItems.map((item, index) => (
                <div className="roles-kpi-card" key={index}>
                    <div className="roles-kpi-top">
                        <div className="roles-kpi-icon">
                            {item.icon}
                        </div>
                        <div className="roles-kpi-trend">
                            {item.trend}
                        </div>
                    </div>

                    <div className="roles-kpi-bottom">
                        <p className="roles-kpi-label">
                            {item.title}
                        </p>
                        <h3 className="roles-kpi-value">
                            {item.value}
                        </h3>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ApplicationStatsCards;
